import { STAKE_PRICES } from '../app/constants'

export function cardCalculator(stakedAmount) {
  for (let i = 0; i < STAKE_PRICES.length; i++) {
    if (i === 0) {
      if (parseInt(stakedAmount) <= STAKE_PRICES[i]) {
        return 3
      }
    } else if (i === STAKE_PRICES.length - 1) {
      if (parseInt(stakedAmount) > STAKE_PRICES[i]) {
        return 10
      }
    } else {
      if (
        parseInt(stakedAmount) > STAKE_PRICES[i - 1] &&
        parseInt(stakedAmount) <= STAKE_PRICES[i]
      ) {
        return i + 3
      }
    }
  }
}
